import { setMeta } from '@/helpers/metaHelpers'

export default {
  emits: ['updateTitle'],
  watch: {
    $page(to) {
      setMeta(to.seo)
      this.$emit('updateTitle', this.$page.seo.title)
    },
  },
  mounted() {
    if (this.$page) {
      this.$emit('updateTitle', this.$page.seo.title)
      setMeta(this.$page.seo)
    }
  },
}
